import React from 'react';
import ShareRedirect from './share-redirect';

const ShareReferral = () => <ShareRedirect shareType="referral" />;

export default ShareReferral;
